// extracted by mini-css-extract-plugin
module.exports = {"SlideIn":"slide_SlideIn__Fk2gx","Show":"slide_Show__gFpqw","Light":"slide_Light__m_NKp","Dark":"slide_Dark__TPddi"};